module.exports = __webpack_public_path__ + "static/media/ICON_FIND_ECP.5d1b82fb.svg";